import {
  CONFIRMAR_LIBERACAO_TOTAL,
  EXIBIR_MODAL_LIBERACAO_TOTAL,
} from './liberacaoTotal.action';

const ESTADO_INICIAL = {
  modalAberto: false,
  laudo: {},
};

const modalLiberacaoTotaoReducer = (state = ESTADO_INICIAL, action) => {
  switch (action.type) {
    case CONFIRMAR_LIBERACAO_TOTAL:
      return { ...state, laudo: state.laudo };
    case EXIBIR_MODAL_LIBERACAO_TOTAL:
      return { ...state, modalAberto: !state.modalAberto };
    default:
      return state;
  }
};

export default modalLiberacaoTotaoReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_total/store/liberacaoTotal.reducer.js